import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhvckrk4ev: FaireProductEntity = {
  token: "p_hhvckrk4ev",
  type: "product",
  name: "Beach sun pendant necklace, stainless steel, 18K gold PVD, waterproof",
  brandToken: "b_3t5pew5dxb",
  brandName: "Minimalistajoyeria",
  imageUrl:
    "https://cdn.faire.com/fastly/88fe42da49623bfe647604cfc075642451a08a7e39f6aff11045419dae55d5d0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e9bd7df7bb5069600404c3084b3b9a426a010f2646700ea1eeeb717cd84a54b.png",
    "https://cdn.faire.com/fastly/60e43fb04f57f1d1720103c80264c82266de4d078ca1f0d56ae852f674e286ad.jpeg",
    "https://cdn.faire.com/fastly/01ba35570743cb0ef1ccc00ea9309585caa4579eec94fee4dd2ed0e8f7f3dbac.jpeg",
    "https://cdn.faire.com/fastly/a1893dd238d15c3fe70deab419b9598b1f9d1d2bb726be31d104ccc8355edeb6.jpeg",
    "https://cdn.faire.com/fastly/309386885844df6547c33f331757f44cf6e03b7f60b3726ee97f7a2bfb1228bf.jpeg",
    "https://cdn.faire.com/fastly/7af0ba5bc47e5ee078e43d00cf4baa461407da836fa32d2e4bbcd3e9446b3394.jpeg",
  ],
  priceDollars: 3.03,
  description:
    "Premium Material: Stainless steel with 18K gold vacuum plating (PVD Waterproof); water-resistant, durable, and does not tarnish.  \nFinish: Polished shine  \nHypoallergenic: Safe for sensitive skin; does not stain or irritate.  \nLength: 40cm plus 5cm of slightly adjustable extension  \n\nStock in Spain: Fast shipping and no customs.  \n\nDirect Price: Luxury aesthetics at factory price.",
  tags: [],
  msrpDollars: 10.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:23.194Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
